import * as p from "react";
import { Item as v } from "../Item.mjs";
function R(r, e, n, a, f, m) {
  var o = m.getKey;
  return r.slice(e, n + 1).map(function(t, u) {
    var i = e + u, c = f(t, i, {
      // style: status === 'MEASURE_START' ? { visibility: 'hidden' } : {},
    }), s = o(t);
    return /* @__PURE__ */ p.createElement(v, {
      key: s,
      setRef: function(l) {
        return a(t, l);
      }
    }, c);
  });
}
export {
  R as default
};
//# sourceMappingURL=useChildren.mjs.map
